"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const polaris_1 = require("@shopify/polaris");
//
// assets
//
const primaryLogo_webp_1 = __importDefault(require("assets/images/primaryLogo.webp"));
//
// styles
//
const StyledContainer_1 = require("./StyledContainer");
const StyledLogo_1 = require("./StyledLogo");
const OnboardingHeader = (props) => {
    return (react_1.default.createElement(StyledContainer_1.StyledContainer, null,
        react_1.default.createElement(StyledLogo_1.StyledLogo, { alt: 'Malomo', src: primaryLogo_webp_1.default }),
        react_1.default.createElement(polaris_1.Text, { as: 'h4', variant: 'headingXl' }, props.header)));
};
OnboardingHeader.propTypes = {
    header: prop_types_1.default.string
};
exports.default = OnboardingHeader;
